/* eslint-disable indent no-tabs no-mixed-spaces-and-tabs*/
import firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/functions'

const config = {
    apiKey: "AIzaSyA3J7GON5C7clwkogWgh_ZuTXA3dm5xlfs",
    authDomain: "lesrelaiscartegrise-192e7.firebaseapp.com",
    databaseURL: "https://lesrelaiscartegrise-192e7.firebaseio.com",
    projectId: "lesrelaiscartegrise-192e7",
    storageBucket: "lesrelaiscartegrise-192e7.appspot.com",
    messagingSenderId: "498958513579",
    appId: "1:498958513579:web:2190f7ddd5e0ed69370eee",
    measurementId: "G-PVMP72P6GL"
}
firebase.initializeApp(config)
firebase.analytics()

const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage();
const functions = firebase.functions();



// firebase collections
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')

export {
    db,
    auth,
    storage,
    functions,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js